import { computed } from 'vue'
import store from '@/store'

export default function useDiscountCard() {
  const discountCards = computed(() => store.getters['info/getDiscountCards'])

  return {
    discountCards
  }
}